import ClubGoalMembersAccordion from './ClubGoalMembersAccordion';

export default ClubGoalMembersAccordion;
